module.exports = __webpack_public_path__ + "img/gift3.d76e8e48.png";